<template>
  <el-dialog v-model="dialogVisible" :title="title" v-if="dialogVisible">
    <div>
      <el-scrollbar>
        <el-form
          :model="dialogModel"
          :rules="dialogRules"
          ref="dialogRef"
          label-width="120px"
        >
          <el-row>
            <template v-for="(f, fIndex) in dialogForm" :key="fIndex">
              <el-col
                :span="f?.colSpan ?? 12"
                v-if="f.showCondition ? f.showCondition(dialogModel) : true"
              >
                <el-form-item :label="f.label" :prop="f.value">
                  <component
                    v-bind="f"
                    v-bind:value="dialogModel[f.value]"
                    v-model="dialogModel[f.value]"
                    :is="f.component ? f.component : 'el-input'"
                    :placeholder="f.placeholder ? f.placeholder : '请输入'"
                    :params="
                      f.getParams ? f.getParams(dialogModel) : f?.params ?? null
                    "
                    :style="{ width: '100%' }"
                  ></component>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit"> 确定 </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import dialogMixin from "./dialogMixin";
export default defineComponent({
  components: {},
  mixins: [dialogMixin],
  props: {
    /** 本组件需要用上的接口
     * @values {add,edit,detail}
     */
    api: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
    /** 弹框标题 */
    title: {
      type: String,
      default: "",
      required: true,
    },
    /** 弹框显示/关闭 */
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const dialogRef = ref();
    const state = reactive({
      dialogVisible: false,
      dialogModel: {},
    });
    onMounted(() => {});

    //弹框点击保存
    const handleSubmit = () => {
      dialogRef.value.validate((valid, fields) => {
        if (valid) {
          emit("submit", state.dialogModel);
        }
      });
    };
    watch(
      () => props.modelValue,
      (n) => {
        state.dialogVisible = n;
      }
    );
    watch(
      () => state.dialogVisible,
      (n) => {
        if (!n) {
          emit("update:modelValue", false);
        }
      }
    );
    return {
      ...toRefs(state),
      dialogRef,
      handleSubmit,
    };
  },
});
</script>
<style scoped lang="less"></style>
